import React, { ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

type Props = FieldRenderProps<string> & {
  placeholder: string;
  required?: boolean;
  className?: string;
  readOnly?: boolean;
  customError?: string;
  onChange?: () => void;
};

type State = {
  fieldType: string,
};

class DateInput extends React.Component<Props, State> {
  static defaultProps = {
    required: false,
    className: '',
    readOnly: false,
  };

  state: State = {
    fieldType: 'text',
  };

  onFocus = (): void => {
    if (this.state.fieldType === 'text') {
      this.setState({ fieldType: 'date' });
    }
  };

  onBlur = (): void => {
    if (!this.props.input.value) {
      this.setState({ fieldType: 'text' });
    }
  };

  render(): ReactNode {
    const htmlFor = this.props.input.name;
    return (
      <div className={`${this.props.className} text-input-group ${this.props.meta.touched && (this.props.meta.error || this.props.customError) ? 'input-error' : ''}`}>
        <input
          type={this.state.fieldType}
          className={`text-input-field date-input-field ${this.props.readOnly && 'read-only'}`}
          value={this.props.input.value}
          onChange={(e) => {
            this.props.input.onChange(e);
          }}
          placeholder={this.props.placeholder}
          id={htmlFor}
          required={this.props.required}
          readOnly={this.props.readOnly}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        <label htmlFor={htmlFor} className={`text-input-placeholder ${this.props.required && 'text-input-placeholder--mandatory'}`}>{this.props.placeholder}</label>
        {
          this.props.input.value && !this.props.readOnly && (
            <button
              className="text-input-button-container"
              onClick={() => {
                this.props.input.onChange(null);
                this.setState({ fieldType: 'text' });
              }}
              type="button"
            >
              <i className="fa fa-times" />
            </button>
          )
        }
        {
          this.props.meta.touched && (
            (this.props.customError && <span className="text-error">{this.props.customError}</span>)
            || (this.props.meta.error && <span className="text-error">{this.props.meta.error}</span>)
          )
        }
      </div>
    );
  }
}

export default DateInput;
